import {
  PROFILE_FOOTERS_IN_ORDER,
  INIT_CATEGORIES,
  DETAILS_IN_ORDER,
} from 'enrollment/components/BottomNavigation/utils';

export const getMaxHeaderIndex = (status: string, requiredTask: string) => {
  // this is only to initialize the stauts of the header when starting a new session
  if (status === 'undefined' && requiredTask === 'confirm') {
    return 3;
  }

  if (PROFILE_FOOTERS_IN_ORDER.includes(status)) {
    return 0;
  } else if (INIT_CATEGORIES.includes(status)) {
    return 1;
  } else if (
    status === 'details' ||
    DETAILS_IN_ORDER.includes(status) ||
    status === 'confirm'
  ) {
    return 2;
  }
  return 0;
};
